import ShoppingCart from '@mui/icons-material/ShoppingCart'
import Payments from '@mui/icons-material/Payments'
import CreditCard from '@mui/icons-material/CreditCard'
import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline'
import Paid from '@mui/icons-material/Paid'
import SwitchAccount from '@mui/icons-material/SwitchAccount'
import ManageAccounts from '@mui/icons-material/ManageAccounts'
import SettingsIcon from '@mui/icons-material/Settings'
import AddCardIcon from '@mui/icons-material/AddCard'
import InfoIcon from '@mui/icons-material/Info'
import QuestionMarkIcon from '@mui/icons-material/QuestionMark'
import { CalendarMonth } from '@mui/icons-material'
import TelegramIcon from '@mui/icons-material/Telegram'
import ChecklistIcon from '@mui/icons-material/Checklist'
import AutoStoriesIcon from '@mui/icons-material/AutoStories'
import CodeIcon from '@mui/icons-material/Code'
import { MenuFolder, MenuLink } from './Menu'

export type MenuItems = (MenuLink | MenuFolder)[]

export const menuItems: MenuItems = [
  { to: '/sales', name: 'Sales', icon: <ShoppingCart /> },
  {
    to: '/orders',
    name: 'Orders',
    roles: ['VENDOR'],
    icon: <AutoStoriesIcon />
  },
  {
    to: '/review-queue',
    name: 'Review Queue',
    roles: ['VENDOR'],
    icon: <ChecklistIcon />
  },
  {
    to: '/calendar',
    name: 'Calendar',
    roles: ['PUBLISHER', 'AFFILIATE'],
    icon: <CalendarMonth />
  },
  {
    name: 'Earnings',
    icon: <Payments />,
    unfolded: true,
    items: [
      { to: '/earnings/summary', name: 'Earnings', icon: <Paid /> },
      {
        to: '/earnings/deductions',
        name: 'Deductions',
        roles: ['PUBLISHER', 'VENDOR'],
        icon: <RemoveCircleOutline />
      },
      {
        to: '/earnings/payment-status',
        name: 'Payment Status',
        icon: <CreditCard />
      }
    ]
  },
  { to: '/stack-media', name: 'StackMedia', icon: <TelegramIcon /> },
  {
    to: '/resources',
    name: 'Resources',
    roles: ['PUBLISHER', 'AFFILIATE'],
    icon: <CodeIcon />
  },
  {
    name: 'Account',
    icon: <SettingsIcon />,
    unfolded: true,
    items: [
      { to: '/account/general-info', name: 'General Info', icon: <InfoIcon /> },
      {
        to: '/account/payment-info',
        name: 'Payment Info',
        icon: <AddCardIcon />
      },
      {
        to: '/account/manage-users',
        name: 'Manage Users',
        icon: <ManageAccounts />
      }
    ]
  },
  {
    to: 'https://www.stacksocial.com/help/vendor_success',
    name: 'Help',
    role: 'VENDOR',
    icon: <QuestionMarkIcon />
  },
  {
    to: '/roles',
    name: 'Role Select',
    multirole: true,
    icon: <SwitchAccount />
  }
]
